export default "__VITE_ASSET__BtPp2lrK__"